export var firebaseConfig = {
    apiKey: "AIzaSyCDGk6TE7edA1Fu0Hh6UmN77d6wUKUc4qI",
    authDomain: "tr-dev-daemon.firebaseapp.com",
    databaseURL: "https://tr-dev-daemon-default-rtdb.firebaseio.com",
    projectId: "tr-dev-daemon",
    storageBucket: "tr-dev-daemon.appspot.com",
    messagingSenderId: "274244382155",
    appId: "1:274244382155:web:f4b38c1f8fc91878ea9a4e",
};



//////////////////
// WEBPACK FOOTER
// ./src/FirebaseConfig.ts
// module id = 25
// module chunks = 0